import React, { useState } from 'react';

const Contact = ({ currentLanguage = 'KM' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const getFontClass = () => {
    return currentLanguage === 'KM' ? 'font-khmer' : 'font-inter';
  };

  const content = {
    EN: {
      title: "Contact Us",
      subtitle: "Get in Touch With Us",
      description: "Have a question or ready to book? Send us a message and we'll get back to you as soon as possible.",
      form: {
        name: "Full Name",
        namePlaceholder: "Enter your name",
        email: "Email Address",
        emailPlaceholder: "your@email.com",
        phone: "Phone Number",
        phonePlaceholder: "077221295",
        service: "Service Interested",
        servicePlaceholder: "Select a service",
        message: "Message",
        messagePlaceholder: "Tell us what you need...",
        submitButton: "Send Message"
      },
      services: [
        "Hair Styling",
        "Hair Coloring",
        "Spa & Massage",
        "Facial Care",
        "Nail Care",
        "Makeup Artistry"
      ],
      contactInfo: {
        title: "Our Branches & Contact",
        hotline: "077221295",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda",
        branches: [
          {
            name: "Branch 1 - SARYDA BEAUTY CLINIC",
            address: "Behind Nak Tiev, Street to Sra Pidil, about 800m past Nak Tiev",
            hours: "9am - 2am (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/NrdU6zR31NENcwYq7?g_st=ic"
          },
          {
            name: "Branch 2 - The King International spa and clinic",
            address: "Street No.3, Kampong Svay, Serei Sophorn, Banteay Meanchey",
            hours: "8:30am - 7pm (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/nnrnG8sCVGCD6R2LA?g_st=com.google.maps.preview.copy"
          },
          {
            name: "Branch 3",
            address: "Near Tuol Kok Market, Street 614",
            hours: "9am - 10pm (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/U3H9JTn1LfCESJF57"
          }
        ]
      },
      social: {
        title: "Follow Us",
        platforms: ["Facebook", "Instagram", "Telegram"]
      }
    },
    KM: {
      title: "ទំនាក់ទំនងយើង",
      subtitle: "ទំនាក់ទំនងជាមួយយើង",
      description: "មានសំណួរ ឬត្រៀមខ្លួនកក់? ផ្ញើសារមកយើង ហើយយើងនឹងឆ្លើយតបអ្នកឱ្យបានឆាប់តាមដែលអាចធ្វើទៅបាន។",
      form: {
        name: "ឈ្មោះពេញ",
        namePlaceholder: "បញ្ចូលឈ្មោះរបស់អ្នក",
        email: "អាសយដ្ឋានអ៊ីមែល",
        emailPlaceholder: "your@email.com",
        phone: "លេខទូរសព្ទ",
        phonePlaceholder: "០៧៧២២១២៩៥",
        service: "សេវាកម្មដែលចាប់អារម្មណ៍",
        servicePlaceholder: "ជ្រើសរើសសេវាកម្ម",
        message: "សារ",
        messagePlaceholder: "ប្រាប់យើងអំពីអ្វីដែលអ្នកត្រូវការ...",
        submitButton: "ផ្ញើសារ"
      },
      services: [
        "ការធ្វើសក់",
        "ពណ៌សក់",
        "ស្ប៉ា និងម៉ាស្សា",
        "ថែទាំមុខ",
        "ថែទាំក្រចក",
        "ការតុបតែងមុខ"
      ],
      contactInfo: {
        title: "សាខា និងព័ត៌មានទំនាក់ទំនង",
        hotline: "០៧៧២២១២៩៥",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda",
        branches: [
          {
            name: "សាខាទី១ - SARYDA BEAUTY CLINIC",
            address: "ផ្លូវក្រោយនាគទិព្វ ផ្លូវទៅស្រាផ្ទិល ហួសនាគទិព្វប្រហែល 800 ម៉ែត្រ",
            hours: "9am - 2am (រាល់ថ្ងៃ)",
            phone: "០៧៧២២១២៩៥",
            mapLink: "https://maps.app.goo.gl/NrdU6zR31NENcwYq7?g_st=ic"
          },
          {
            name: "សាខាទី២ - The King International spa and clinic",
            address: "ផ្លូវលេខ៣ កំពង់ស្វាយ សិរីសោភ័ណ បន្ទាយមានជ័យ",
            hours: "8:30am - 7pm (រាល់ថ្ងៃ)",
            phone: "០៧៧២២១២៩៥",
            mapLink: "https://maps.app.goo.gl/nnrnG8sCVGCD6R2LA?g_st=com.google.maps.preview.copy"
          },
          {
            name: "សាខាទី៣",
            address: "ក្បែរផ្សារទួលគោក, ផ្លូវលេខ 614",
            hours: "9am - 10pm (រាល់ថ្ងៃ)",
            phone: "០៧៧២២១២៩៥",
            mapLink: "https://maps.app.goo.gl/U3H9JTn1LfCESJF57"
          }
        ]
      },
      social: {
        title: "តាមដានយើង",
        platforms: ["ហ្វេសប៊ុក", "អ៊ីនស្តាក្រាម", "តេឡេក្រាម"]
      }
    }
  };

  const currentContent = content[currentLanguage] || content.KM;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('បានដាក់ស្នើទម្រង់:', formData);
    alert(currentLanguage === 'EN' ? 'Message sent successfully!' : 'បានផ្ញើសារដោយជោគជ័យ!');
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Battambang:wght@300;400;500;600;700&display=swap');
        
        .font-khmer {
          font-family: 'Battambang', 'Khmer OS', 'Noto Sans Khmer', sans-serif;
        }

        .font-inter {
          font-family: 'Inter', 'Battambang', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
      `}</style>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold text-gray-900 mb-3 ${getFontClass()}`}>
              {currentContent.title}
            </h2>
            <p className={`text-xl text-[#f2c742] font-semibold mb-4 ${getFontClass()}`}>
              {currentContent.subtitle}
            </p>
            <p className={`text-lg text-gray-600 max-w-2xl mx-auto ${getFontClass()}`}>
              {currentContent.description}
            </p>
          </div>

          {/* Hotline Banner */}
          <div className="mb-8 bg-gradient-to-r from-[#f2c742] to-[#e0b53a] rounded-lg p-4 text-center">
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a 
                href={`tel:${currentContent.contactInfo.hotline}`}
                className="flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="font-semibold">{currentContent.contactInfo.hotline}</span>
              </a>
              <a 
                href={currentContent.contactInfo.telegramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <span>Telegram: {currentContent.contactInfo.telegram}</span>
              </a>
            </div>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            
            {/* Contact Form - 2 columns */}
            <div className="lg:col-span-2 bg-gray-50 rounded-lg shadow-md p-6 md:p-8">
              <h3 className={`text-2xl font-bold text-gray-900 mb-6 ${getFontClass()}`}>
                {currentLanguage === 'EN' ? 'Send us a Message' : 'ផ្ញើសារមកយើង'}
              </h3>
              
              <form onSubmit={handleSubmit} className="space-y-5">
                {/* Name */}
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${getFontClass()}`}>
                    {currentContent.form.name}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={currentContent.form.namePlaceholder}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent ${getFontClass()}`}
                    required
                  />
                </div>

                {/* Email & Phone */}
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className={`block text-gray-700 font-semibold mb-2 ${getFontClass()}`}>
                      {currentContent.form.email}
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={currentContent.form.emailPlaceholder}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent ${getFontClass()}`}
                      required
                    />
                  </div>
                  <div>
                    <label className={`block text-gray-700 font-semibold mb-2 ${getFontClass()}`}>
                      {currentContent.form.phone}
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder={currentContent.form.phonePlaceholder}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent ${getFontClass()}`}
                      required
                    />
                  </div>
                </div>

                {/* Service */}
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${getFontClass()}`}>
                    {currentContent.form.service}
                  </label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent bg-white ${getFontClass()}`}
                    required
                  >
                    <option value="">{currentContent.form.servicePlaceholder}</option>
                    {currentContent.services.map((service, index) => (
                      <option key={index} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Message */}
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${getFontClass()}`}>
                    {currentContent.form.message}
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={currentContent.form.messagePlaceholder}
                    rows="5"
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent resize-none ${getFontClass()}`}
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className={`w-full bg-[#f2c742] hover:bg-[#e0b53a] text-gray-900 py-3 rounded-lg font-semibold text-lg transition-colors ${getFontClass()}`}
                >
                  {currentContent.form.submitButton}
                </button>
              </form>
            </div>

            {/* Contact Information - 1 column */}
            <div className="space-y-6">
              
              {/* Branch Information */}
              <div className="bg-gray-50 rounded-lg shadow-md p-6">
                <h3 className={`text-xl font-bold text-gray-900 mb-6 ${getFontClass()}`}>
                  {currentContent.contactInfo.title}
                </h3>

                <div className="space-y-6">
                  {currentContent.contactInfo.branches.map((branch, idx) => (
                    <div key={idx} className="border-b border-gray-200 last:border-b-0 pb-4 last:pb-0">
                      <h4 className={`font-bold text-gray-900 mb-2 ${getFontClass()}`}>
                        {branch.name}
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-start gap-2">
                          <svg className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span className="text-gray-600 font-inter">{branch.address}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <span className="text-gray-600 font-inter">{branch.hours}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                          </svg>
                          <a 
                            href={`tel:${branch.phone}`}
                            className={`text-[#f2c742] hover:text-[#e0b53a] font-semibold font-inter`}
                          >
                            {branch.phone}
                          </a>
                        </div>
                        <a 
                          href={branch.mapLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 text-sm text-[#f2c742] hover:text-[#e0b53a] font-semibold mt-1"
                        >
                          📍 {currentLanguage === 'EN' ? 'View on Map →' : 'មើលផែនទី →'}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="bg-[#f2c742] rounded-lg shadow-md p-6 text-gray-900">
                <h3 className={`text-xl font-bold mb-4 ${getFontClass()}`}>
                  {currentContent.social.title}
                </h3>
                <div className="flex space-x-3">
                  {/* Facebook */}
                  <a 
                    href="https://www.facebook.com/people/The-Gilded-OWL-Nail-salon-SPA/61580336022975/" 
                    className="w-10 h-10 bg-gray-900 bg-opacity-20 hover:bg-opacity-30 rounded-lg flex items-center justify-center transition-all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  {/* Instagram */}
                  <a 
                    href="https://www.instagram.com/kimhuotlim?igsh=cmhxYmswcjF6Nm82&utm_source=qr" 
                    className="w-10 h-10 bg-gray-900 bg-opacity-20 hover:bg-opacity-30 rounded-lg flex items-center justify-center transition-all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                  {/* Telegram */}
                  <a 
                    href={currentContent.contactInfo.telegramLink}
                    className="w-10 h-10 bg-gray-900 bg-opacity-20 hover:bg-opacity-30 rounded-lg flex items-center justify-center transition-all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg className="w-5 h-5 text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;